import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { toast } from "sonner";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login, API } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing (especially in StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Authentication failed");
        navigate("/login");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await fetch(`${API}/auth/session?session_id=${sessionId}`);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.detail || "Authentication failed");
        }

        // Log the user in
        login(data.user, data.token);
        toast.success("Welcome!");

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // Redirect based on role
        if (data.user.role === "admin" || data.user.role === "consultant") {
          navigate("/admin", { replace: true });
        } else {
          navigate("/portal", { replace: true });
        }
      } catch (error) {
        toast.error("Authentication failed. Please try again.");
        navigate("/login");
      }
    };

    processAuth();
  }, [API, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rnb-light to-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-rnb-blue border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-rnb-gray">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
